import { Modal, View, Text, TouchableOpacity, SafeAreaView, ScrollView, useWindowDimensions } from 'react-native';
import { useCssStyle } from '../../customHook/getCssStyle';
import React, { useEffect, useMemo, useState } from 'react';
import CustomPressable from '../../components/customPressable/customPressable';
import CustomCheckBoxWithProps from '../../components/checkBox/customCheckBox';
import { useTranslation } from 'react-i18next';
import { CustomModal } from '../../components/customModal';
import { CROSS, MINUS, PLUS } from '../../assets';
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl } from '../../utils/Helper';
import { useSelector } from 'react-redux';
import RenderHTML from 'react-native-render-html';

const ItemAddOnsPopup = props => {
  const {
    itemAddOnsInfo,
    cartItem,
    selectedStoreItem,
    handleCloseAddOnsPopup,
    handleAddToCart,
    handleRemoveFromCart,
  } = props || {};

  const getStyles = useCssStyle();
  const { t } = useTranslation();
  const { width } = useWindowDimensions()
  

  const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
  const currencyCode = currencyDetails.code;

  const [showCustomizePage, setShowCustomizePage] = useState(false);

  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [itemQuantity, setItemQuantity] = useState(1);

  const handleAddOn = addOnInfo => {
    if (
      selectedAddOns.some(selectedAddOn => selectedAddOn.id === addOnInfo.id)
    ) {
      setSelectedAddOns(
        selectedAddOns.filter(
          selectedAddOn => selectedAddOn.id !== addOnInfo.id,
        ),
      );
    } else {
      const updatedAddOns = [...selectedAddOns, addOnInfo].sort(
        (a, b) => a.id - b.id,
      );
      setSelectedAddOns(updatedAddOns);
    }
  };

  const handleAddItem = () => {
    handleAddToCart(
      { ...selectedStoreItem, quantity: itemQuantity },
      selectedAddOns,
      true,
    );
    handleCloseAddOnsPopup();
  };

  useEffect(() => {
    if (
      cartItem.filter(item => item.itemInfo.id === selectedStoreItem.id).length > 0

    ) {
      setShowCustomizePage(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customWidgetTitleStyle = useMemo(() => {
    const style = getStyles([`AddOnsModalContent_childcontainer_header_container_title`]);
    return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customAddOnItemTitleStyle = useMemo(() => {
    const style = getStyles(['list_itemContainer_textContainer_title', 'AddOnsModalContent_addons_itemContainer_textContainer_title']);
    return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customAddOnItemSubTitleStyle = useMemo(() => {
    const style = getStyles(['list_itemContainer_textContainer_subtitle', 'AddOnsModalContent_addons_itemContainer_textContainer_subtitle']);
    return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CustomModal onRequestClose={handleCloseAddOnsPopup}>

      <View style={getStyles(['AddOnsModalContent'])} id='AddOnsModalContent'>

        <SafeAreaView style={getStyles(['crossOverContainer_Container'])} id='crossOverContainer_Container'>
          <CustomPressable style={getStyles(['crossOverContaniner_Cross'])} onPress={handleCloseAddOnsPopup} id='crossOverContaniner_Cross'>
            <ImageComp source={CROSS} />
          </CustomPressable>
        </SafeAreaView>

        {showCustomizePage ? (

          <View showsVerticalScrollIndicator={false} style={getStyles(['AddOnsModalContent_maincontainer'])}>
            <View style={getStyles(['AddOnsModalContent_childcontainer_header_container'])} id='AddOnsModalContent_childcontainer_header_container'>
              <Text style={getStyles(['AddOnsModalContent_childcontainer_header_container_title'])} id='AddOnsModalContent_childcontainer_header_container_title'>{t('h-commerce.your_customization')}</Text>
            </View>

            <View style={getStyles(['AddOnsModalContent_childcontainer'])} id='AddOnsModalContent_childcontainer'>

              <View style={getStyles(['AddOnsModalContent_addons_main_container'])} id='AddOnsModalContent_addons_main_container'>
                <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={getStyles(['AddOnsModalContent_addons_child_container'])} id='AddOnsModalContent_addons_child_container'>
                  {cartItem.map((cartItemInfo, index) => {
                    if (cartItemInfo.itemInfo.id == selectedStoreItem.id) {
                      return (
                        <View style={getStyles(['list_itemContainer', 'AddOnsModalContent_addons_itemContainer'])} id='list_itemContainer AddOnsModalContent_addons_itemContainer'>

                          <View style={getStyles(['list_itemContainer_textContainer', 'AddOnsModalContent_addons_itemContainer_textContainer'])} id='list_itemContainer_textContainer AddOnsModalContent_addons_itemContainer_textContainer'>
                            <RenderHTML
                              contentWidth={width}
                              baseStyle={customAddOnItemTitleStyle}
                              source={{ html: cartItemInfo.itemInfo.itemName}}
                              systemFonts={[customAddOnItemTitleStyle.fontFamily]}
                              id='list_itemContainer_textContainer_title AddOnsModalContent_addons_itemContainer_textContainer_title'
                              defaultTextProps={{
                                numberOfLines: 1
                              }}
                            />
                            <Text style={getStyles(['list_itemContainer_textContainer_subtitle', 'AddOnsModalContent_addons_itemContainer_textContainer_subtitle'])} id='list_itemContainer_textContainer_subtitle AddOnsModalContent_addons_itemContainer_textContainer_subtitle'>{cartItemInfo.addOns.map(addOnItem => addOnItem.name).join(', ')}</Text>
                          </View>

                          <View style={getStyles(['additem_controls2'])} id='additem_controls2'>
                            <CustomPressable
                              onPress={() => handleRemoveFromCart(selectedStoreItem, index)}
                              style={getStyles(['additem_controls_sub_container2'])}
                              id='additem_controls_sub_container2'
                            >
                              <ImageComp source={MINUS} style={getStyles(['additem_controls_sub_container_img2'])} id='additem_controls_sub_container_img2' />
                            </CustomPressable>
                            <Text style={getStyles(['additem_controls_qty_text2'])} id='additem_controls_qty_text2'>{cartItemInfo.quantity}</Text>
                            <CustomPressable onPress={() => handleAddToCart(
                              selectedStoreItem,
                              cartItemInfo.addOns,
                              true,
                            )} style={getStyles(['additem_controls_sub_container2'])} id='additem_controls_sub_container2'>
                              <ImageComp source={PLUS} style={getStyles(['additem_controls_sub_container_img2'])} id='additem_controls_sub_container_img2' />
                            </CustomPressable>

                          </View>

                        </View>
                      );
                    }
                    return null;
                  })}
                </ScrollView>
              </View>

              <CustomPressable style={getStyles(['primaryBtn'])} onPress={() => setShowCustomizePage(false)} id='primaryBtn'>
                <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('h-commerce.add_new_customization')}</Text>
              </CustomPressable>
            </View>
          </View>
        ) : (

          <View showsVerticalScrollIndicator={false} style={getStyles(['AddOnsModalContent_maincontainer'])}>
            <View style={getStyles(['AddOnsModalContent_childcontainer_header_container'])} id='AddOnsModalContent_childcontainer_header_container'>
              {/* <Text style={getStyles(['AddOnsModalContent_childcontainer_header_container_title'])} id='AddOnsModalContent_childcontainer_header_container_title'>{selectedStoreItem.itemName}</Text> */}
              <RenderHTML
                contentWidth={width}
                baseStyle={customWidgetTitleStyle}
                source={{ html: selectedStoreItem.itemName}}
                systemFonts={[customWidgetTitleStyle.fontFamily]}
                id={`AddOnsModalContent_childcontainer_header_container_title`}
              />

              <Text style={getStyles(['AddOnsModalContent_childcontainer_header_container_subtitle'])} id='AddOnsModalContent_childcontainer_header_container_subtitle'>{currencyCode + selectedStoreItem.itemPrice}</Text>
            </View>

            <View style={getStyles(['AddOnsModalContent_childcontainer'])} id='AddOnsModalContent_childcontainer'>


              <View style={getStyles(['AddOnsModalContent_addons_main_container'])} id='AddOnsModalContent_addons_main_container'>
                <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={getStyles(['AddOnsModalContent_addons_child_container'])} id='AddOnsModalContent_addons_child_container'>
                  {itemAddOnsInfo.map((addOnsInfo, index) => {

                    if (addOnsInfo.storeItemId == selectedStoreItem.id) {
                      return (

                        <View style={getStyles(['list_itemContainer', 'AddOnsModalContent_addons_itemContainer'])} id='list_itemContainer AddOnsModalContent_addons_itemContainer'>

                          {addOnsInfo.largeImage &&
                            <View style={getStyles(['list_itemContainer_image', 'AddOnsModalContent_addons_itemContainer_image'])} id='list_itemContainer_image AddOnsModalContent_addons_itemContainer_image'>
                              <ImageComp
                                source={getCleanUrl(addOnsInfo.largeImage)}
                                style={getStyles([ "AddOnsModalContent_addons_item_image", { width: "100%", height: "100%" }])}
                                id="AddOnsModalContent_addons_item_image"
                              />
                            </View>
                          }

                          <View style={getStyles(['list_itemContainer_textContainer', 'AddOnsModalContent_addons_itemContainer_textContainer'])} id='list_itemContainer_textContainer AddOnsModalContent_addons_itemContainer_textContainer'>
                          <RenderHTML
                              contentWidth={width}
                              baseStyle={customAddOnItemTitleStyle}
                              source={{ html: addOnsInfo.name}}
                              systemFonts={[customAddOnItemTitleStyle.fontFamily]}
                              id='list_itemContainer_textContainer_title AddOnsModalContent_addons_itemContainer_textContainer_title'
                              defaultTextProps={{
                                numberOfLines: 1
                              }}
                            />
                            {addOnsInfo.description &&
                              <RenderHTML
                                contentWidth={width}
                                baseStyle={customAddOnItemSubTitleStyle}
                                source={{ html: addOnsInfo.description}}
                                systemFonts={[customAddOnItemSubTitleStyle.fontFamily]}
                                id='list_itemContainer_textContainer_subtitle AddOnsModalContent_addons_itemContainer_textContainer_subtitle'
                                defaultTextProps={{
                                  numberOfLines: 2
                                }}
                              />
                            }

                            {addOnsInfo.price ? <Text style={getStyles(['list_itemContainer_textContainer_title', 'AddOnsModalContent_addons_itemContainer_textContainer_price'])} id='list_itemContainer_textContainer_title AddOnsModalContent_addons_itemContainer_textContainer_price'>{currencyCode + addOnsInfo.price}</Text> : null}
                          </View>

                          <CustomCheckBoxWithProps
                            value={selectedAddOns.some(selectedAddOn => selectedAddOn.id === addOnsInfo.id)}
                            onValueChange={() => handleAddOn(addOnsInfo)}
                          />

                        </View>
                      );
                    }
                    return null;
                  })}
                </ScrollView>
              </View>

              <View style={getStyles(['AddOnsModalContent_childcontainer_quantity_container'])} id='AddOnsModalContent_childcontainer_quantity_container'>

                <Text style={getStyles(['AddOnsModalContent_childcontainer_quantity_container_text'])} id='AddOnsModalContent_childcontainer_quantity_container_text'>Quantity</Text>

                <View style={getStyles(['additem_controls2'])} id='additem_controls2'>
                  <CustomPressable
                    disabled={itemQuantity <= 1}
                    onPress={() => {
                      if (itemQuantity - 1 > 0)
                        setItemQuantity(itemQuantity - 1);
                    }} style={getStyles(['additem_controls_sub_container2'])}
                    id='additem_controls_sub_container2'
                  >
                    <ImageComp source={MINUS} style={getStyles(['additem_controls_sub_container_img2'])} id='additem_controls_sub_container_img2' />
                  </CustomPressable>
                  <Text style={getStyles(['additem_controls_qty_text2'])} id='additem_controls_qty_text2'>{itemQuantity}</Text>
                  <CustomPressable onPress={() => setItemQuantity(itemQuantity + 1)} style={getStyles(['additem_controls_sub_container2'])} id='additem_controls_sub_container2'>
                    <ImageComp source={PLUS} style={getStyles(['additem_controls_sub_container_img2'])} id='additem_controls_sub_container_img2' />
                  </CustomPressable>

                </View>
              </View>

              <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleAddItem} id='primaryBtn'>
                <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('h-commerce.add_item')}</Text>
              </CustomPressable>

            </View>

          </View>


        )}
      </View>

    </CustomModal>
  );
};


export default ItemAddOnsPopup;